import React, { Suspense, useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import App from "components/App";
import PropTypes from "prop-types";
import { useReactOidc } from "@axa-fr/react-oidc-context";
import PublicApp from "components/PublicApp";
import { getUserManager } from "@axa-fr/react-oidc-core";
import ApplicationLoader, { Loader } from "components/layout/ApplicationLoader";
import { NotificationsToaster } from "components/notifications";
import { publicKeyword } from "features/common/constants";

function WaitingComponent(Component) {
  // eslint-disable-next-line react/display-name
  return (props) => (
    <Suspense fallback={<></>}>
      <Component {...props} />
    </Suspense>
  );
}

const ExposedApp = (props) => {
  const { oidcUser } = useReactOidc();
  const { location } = props;
  const userManager = getUserManager();
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        if (!oidcUser && typeof userManager?.signinSilent === "function") await userManager.signinSilent();
      } catch {
        console.log("... ignoring signinSilent error");
      } finally {
        setLoadingUser(false);
      }
    })();
  }, [oidcUser, userManager]);

  if (loadingUser) return <Loader />;

  return (
    <>
      <ApplicationLoader />
      <NotificationsToaster />
      {oidcUser && !location.pathname.includes(publicKeyword.publicPathName) ? (
        <App {...props} />
      ) : (
        <PublicApp {...props} />
      )}
    </>
  );
};

ExposedApp.propTypes = {
  location: PropTypes.object.isRequired,
};

export default (
  <Switch>
    <Route path={`/`} component={WaitingComponent(ExposedApp)} />
  </Switch>
);
